import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import lighten from 'polished/lib/color/lighten'
import Icon from '../general/Icon'

const AllowedCopies = ({ allowed, className, modest, small, provision }) => (
	<StyledAllowedCopies className={className} allowed={allowed} small={small} modest={modest} provision={provision}>
		{allowed === 0 && <Icon name="ban" size={16} />}
		{allowed === null && provision === null && <Icon name="x" size={14} />}
		{allowed !== null && allowed !== 0 && allowed}
		{provision !== null && provision}
	</StyledAllowedCopies>
)

AllowedCopies.propTypes = {
	allowed: PropTypes.number,
	className: PropTypes.string,
	modest: PropTypes.bool,
	small: PropTypes.bool,
	provision: PropTypes.number
}

AllowedCopies.defaultProps = {
	allowed: null,
	className: null,
	modest: false,
	small: false,
	provision: null
}

export const getAllowedColor = (props, light = false, hover = false) => {
	if (props.allowed === 0 || props.allowed === 1 || props.provision > 50) {
		return props.theme[`red${light ? 'Light' : ''}${hover ? 'Hover' : ''}`]
	}

	if (props.allowed === 2 || props.provision >= 34) {
		return props.theme[`orange${light ? 'Light' : ''}${hover ? 'Hover' : ''}`]
	}

	if (props.allowed === 3) {
		return props.theme[`green${light ? 'Light' : ''}${hover ? 'Hover' : ''}`]
	}

	return light ? props.theme.backgroundLight : props.theme.secondary
}

export const StyledAllowedCopies = styled.div`
	background: ${props => !props.modest || props.theme.id === 'dark' ? getAllowedColor(props) : lighten(0.45, getAllowedColor(props))};
	border-radius: 50%;
	box-shadow: ${props => !props.modest ? `0 0 3px ${props.theme.shadowThick}` : 'none'};
	color: ${props => !props.modest ? props.theme.white : (props.theme.id === 'dark' ? props.theme.white : getAllowedColor(props))};
	font-size: 0.9rem;
	font-weight: bold;

	height: 22px;
	width: 22px;
	min-width: 22px;

	align-items: center;
	display: flex;
	justify-content: center;

	${props => props.small && `
		box-shadow: none;
		font-size: 0.7rem;

		height: 16px;
		width: 16px;
		min-width: 16px;

		svg {
			height: 14px;
			width: 14px;
		}
	`}

	${props => props.provision !== null && `
		border-radius: 4px;
		font-size: 0.8rem;
		font-weight: 600;

		height: 22px;
		width: auto;
		min-width: 22px;
		padding: 0 0.25rem;

		${props.small && `
			height: 16px;
			padding: 0 0.15rem;
		`}
	`}
`

export default AllowedCopies
